module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-update update-form container row"
  }, [_c('div', {
    staticClass: "center col-xs-12 col-sm-12 col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "profile"
  }, [_c('user-image', {
    attrs: {
      "firstname": _vm.currentUser.firstname,
      "lastname": _vm.currentUser.lastname,
      "email": _vm.currentUser.email == 'unknown' ? '' : _vm.currentUser.email,
      "size": "medium",
      "theme": "sensual-lighter"
    }
  }), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.item.email) + " ")]), _vm._v(" "), (_vm.item.organization) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.item.organization.name) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.item.role) ? _c('sensual-badge', {
    attrs: {
      "color": "dark",
      "text": _vm.item.role
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "forgot-password",
    attrs: {
      "to": {
        name: 'password_reset_request'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.meta_info.reset_password')))])], 1), _vm._v(" "), _c('form', {
    staticClass: "profile-update--form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "firstname",
      "label": "models.user.firstname",
      "placeholder": "Andy"
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = $$v
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _c('field', {
    attrs: {
      "errors": _vm.errors,
      "name": "lastname",
      "label": "models.user.lastname",
      "placeholder": "Kaufman"
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = $$v
      },
      expression: "lastName"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "update-form--actions"
  }, [_c('button', {
    staticClass: "btn btn-tertiary",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.global.save')))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc92e590","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/users/UserProfile.vue
// module id = 2013
// module chunks = 0